import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';

const LEGACY_PWA_RELOAD_KEY = 'luxury:pwa-cleanup-reloaded';

async function removeLegacyPwaArtifacts(): Promise<boolean> {
  if (typeof navigator === 'undefined' || !('serviceWorker' in navigator)) return true;

  try {
    const wasControlled = navigator.serviceWorker.controller !== null;
    const registrations = await navigator.serviceWorker.getRegistrations();
    await Promise.all(registrations.map((registration) => registration.unregister()));

    if (typeof caches !== 'undefined') {
      const cacheKeys = await caches.keys();
      await Promise.all(
        cacheKeys.filter((key) => key.startsWith('ngsw:')).map((key) => caches.delete(key)),
      );
    }

    if (wasControlled && sessionStorage.getItem(LEGACY_PWA_RELOAD_KEY) !== 'true') {
      sessionStorage.setItem(LEGACY_PWA_RELOAD_KEY, 'true');
      location.reload();
      return false;
    }

    sessionStorage.removeItem(LEGACY_PWA_RELOAD_KEY);
  } catch {
    // Legacy PWA cleanup must never prevent the storefront from booting.
  }

  return true;
}

void removeLegacyPwaArtifacts().then((shouldBootstrap) => {
  if (!shouldBootstrap) return;
  void bootstrapApplication(AppComponent, appConfig).catch((err) => console.error(err));
});
